import styled from "styled-components";

export interface HeroStringProps {
    isShadow?: boolean;
    isUpdating?: boolean;
}

export const DiscountCounterWrapper = styled.span(({ theme }) => ({
    position: "relative",
    marginRight: theme.spacing.xxSmall,
    lineHeight: theme.spacing.large,
}));

export const HeroString = styled.span<HeroStringProps>(({ isShadow, isUpdating }) => ({
    ...(!isShadow && {
        transition: "transform 100ms",
        position: "absolute",
        left: 0,
    }),
    ...(isShadow && {
        color: "transparent",
        display: "inline-block",
    }),
    ...(isUpdating && {
        transform: "scale(1.05)",
    }),
}));

export const DiscountText = styled.span`
    font-weight: 500;
    &::before {
        content: "\\20b9";
    }
`;
